"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Bold: function() {
        return Bold;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const Bold = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        d: "M6 5.75C6 4.784 6.784 4 7.75 4H12.499C15.322 4 17.25 6.34 17.25 8.75C17.25 9.681 16.962 10.602 16.447 11.382C17.369 12.239 18 13.47 18 15C18 18.133 15.323 20 13 20H7.75C7.28587 20 6.84075 19.8156 6.51256 19.4874C6.18437 19.1592 6 18.7141 6 18.25V5.75ZM9.5 13.5V16.5H13C13.312 16.5 13.71 16.362 14.024 16.079C14.312 15.819 14.5 15.464 14.5 15C14.5 14.112 13.755 13.5 13 13.5H9.5ZM9.5 10H12.5C13.215 10 13.75 9.408 13.75 8.75C13.75 8.093 13.214 7.5 12.499 7.5H9.5V10Z",
        fill: "currentColor"
    })
}), "Bold");
const _default = Bold;
